/**
 * @desc 发货明细保存或更新
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.SystemOrderPackageDeliveryRpcDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/systemOrderPackage/saveOrUpdate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
